import React, { useEffect, useState } from "react";
import { countdownTime } from "../../store/countdownTime";
import Rate from "../Other/Rate";
import { PriceDisplay } from "../Other/PriceDisplay";

function calculatePercentageOffer(price: number, originPrice: number) {
  if (originPrice <= 0) {
    return 0;
  }
  const discount = originPrice - price;
  const percentageOffer = (discount / originPrice) * 100;
  return percentageOffer.toFixed(0);
}

function calculateWidthSold(qte: number, sold: number): number {
  if (qte === 0) {
    return 0; // Avoid division by zero, return 0% if qte is 0
  }

  const widthPerCent = (sold * 100) / qte;
  return widthPerCent;
}

const VenteFlashProduct = (props: any) => {
  const product = props.data;

  const formatDate = (date: any) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  // Get today's date
  const today = new Date();
  const todayFormatted = formatDate(today);

  // Get tomorrow's date
  const tomorrow = new Date();
  tomorrow.setDate(today.getDate() + 1);
  const tomorrowFormatted = formatDate(tomorrow);

  const [timeLeft, setTimeLeft] = useState(countdownTime(todayFormatted));

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(countdownTime(tomorrowFormatted));
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  return (
    <>
      <a
        href={`/product?id=${product.id}`}
        className="fx-reveal flex flex-col relative max-sm:border max-sm:border-orange max-sm:rounded-lg cursor-pointer justify-end items-center 2xl:w-[18.7%] xl:w-[18.7%] lg:w-[20.4%] md:w-[31.4%] sm:w-[47.7%] max-sm:w-[44.7%] animation-img group bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 group-hover:shadow-pink/20 overflow-hidden"
      >
        {/* Shimmer effect overlay */}
        <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000 z-10 pointer-events-none"></div>
        
        {/* Enhanced shadow effect */}
        <div className="absolute inset-0 bg-gradient-to-br from-pink/5 via-transparent to-blue/5 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
        
        <div className="relative overflow-hidden w-full">
          <img
            src={`/images/${product.id}.jpg`}
            width={208}
            height={208}
            alt={product.name}
            onError={(e) => {
              e.currentTarget.src = "/default.png"; 
            }}
            className="object-contain w-full rounded-md group-hover:scale-110 transition-transform duration-500"
          />
        </div>
        <span className="absolute z-10 top-5 right-5 text-sm text-white bg-yellow p-2 rounded-full shadow-md group-hover:scale-105 transition-transform duration-300">
          10%
        </span>
        <div className="w-full p-3 relative z-20">
          <div className="flex justify-center max-sm:justify-start items-center gap-3 mt-3">
            <Rate currentRate={product.rate} size={14} />
          </div>
          <h3 className="font-bold max-sm:text-sm text-center pt-3 pb-2 uppercase truncate overflow-hidden group-hover:text-pink transition-colors duration-300">
            {product.name}
          </h3>
          <div className="flex items-center justify-center gap-2 flex-wrap">
            {product.originPrice === product.price ? (
              <span className="font-semibold text-lg text-orange group-hover:scale-105 transition-transform duration-300">
                <PriceDisplay
                  amount={product.price}
                  size="md"
                  amountClassName="!text-orange"
                  currencyClassName="!text-orange/80"
                />
              </span>
            ) : (
              <>
                <span className="font-semibold text-lg text-orange group-hover:scale-105 transition-transform duration-300">
                  <PriceDisplay
                    amount={product.originPrice}
                    size="md"
                    amountClassName="!text-orange"
                    currencyClassName="!text-orange/80"
                  />
                </span>
                <span className="text-secondary2 text-sm">
                  <del>
                    <PriceDisplay amount={product.price} size="sm" />
                  </del>
                </span>
              </>
            )}
          </div>
          
          <p className="text-center group-hover:text-pink transition-colors duration-300">
            Sold:{" "}
            <span className="text-pink font-bold">{product.sold}</span>
          </p>
          <div className="countdown-time flex items-center gap-1 justify-center mt-2">
            <div className="item flex flex-col items-center">
              <div className="hours time bg-pink text-white p-1 rounded-md flex items-end shadow-md group-hover:shadow-lg transition-shadow duration-300">
                {timeLeft.hours < 10 ? `0${timeLeft.hours}` : timeLeft.hours}{" "}
                <span>H</span>
              </div>
            </div>
            <span className="text-pink">:</span>
            <div className="item flex flex-col items-center">
              <div className="minutes time bg-pink text-white p-1 rounded-md flex items-end shadow-md group-hover:shadow-lg transition-shadow duration-300">
                {timeLeft.minutes < 10
                  ? `0${timeLeft.minutes}`
                  : timeLeft.minutes}{" "}
                <span>M</span>
              </div>
            </div>
            <span className="text-pink">:</span>
            <div className="item flex flex-col items-center">
              <div className="seconds time bg-pink text-white p-1 rounded-md flex items-end shadow-md group-hover:shadow-lg transition-shadow duration-300">
                {timeLeft.seconds < 10
                  ? `0${timeLeft.seconds}`
                  : timeLeft.seconds}{" "}
                <span>S</span>
              </div>
            </div>
          </div>
        </div>
      </a>
    </>
  );
};

export default VenteFlashProduct;


/*<div className="relative w-full h-3 bg-line rounded-full my-3">
            <span
              className="absolute h-full left-0 bg-pink rounded-full"
              style={{
                width: calculateWidthSold(product.quantity, 9) + "%",
              }}
            ></span>
          </div>*/